import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicRoughlyEqual extends DesigntimeComponent {
    static staticName = "Logic: Roughly Equal";
    static staticId = "logicRoughlyEqual";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            limit: { value: 10, dontTranslate: true }
        };

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 },
            parameter2: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicRoughlyEqual'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (this.params.parameter1.key != eventParams.key && this.params.parameter2.key != eventParams.key) {
            return;
        }

        if (eventParams.key == this.params.parameter1.key)
            this.params.parameter1.value = eventParams.value;
        else if (eventParams.key == this.params.parameter2.key)
            this.params.parameter2.value = eventParams.value;
        else
            return;


        var diffPercent = (this.params.parameter1.value - this.params.parameter2.value) / this.params.parameter1.value;

        var res = Math.abs(diffPercent * 100) < this.values.limit.value;

        this.eventBroker.fireValueChanged(this.id, "value", res);
        this.eventBroker.fireValueChanged(this.id, "not_value", !res);
    }

    output = [
        { name: "value", type: "bool" },
        { name: "not_value", type: "bool" }
    ];
}

export { LogicRoughlyEqual }
